import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { appService } from '../_services/app.service';
import { DatePipe } from '@angular/common';
import { DecryptPipe } from '../auth/_services/encrypt-decrypt.pipe';
import { CookieService } from 'ngx-cookie-service';
declare var moment: any;
declare var $: any;

export interface Task {
  id: number;
  tasktitle: string;
  taskdescription: string;
  Taskdateandtime: Date;
  status: string;
}

@Component({
  selector: 'app-task',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.scss'],
  encapsulation: ViewEncapsulation.None,

})
export class TaskComponent implements OnInit {
  static taskComponent: TaskComponent;
  taskDetails: any = {};
  listOfTask: any[] = [];
  showlistOfTask: boolean = true;
  addTaskCheck: boolean = false;
  listOfTaskTemp: any;
  userId: any;

  constructor(
    private _appService: appService,
    public datepipe: DatePipe,
    private decryptpipe: DecryptPipe,
    private cookieService: CookieService,

  ) {
    TaskComponent.taskComponent = this;
  }

  ngOnInit() {
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.getAllTask();
  }

  // Get task api call
  getAllTask() {
    this._appService
      .GetById("Task", "GetTaskList", this.userId)
      .subscribe((response) => {
        let listOfTask = response;
        if (listOfTask) {
          this.listOfTask = listOfTask.slice().sort((a, b) => new Date(b.TaskDatetime).getTime() - new Date(a.TaskDatetime).getTime());
          listOfTask.forEach(x => {
            x.Status = x.Status === 'Completed' ? true : false;
            x.isTodaysDate = !x.Status ? (new Date(x.TaskDatetime).toDateString() === new Date().toDateString() ? true : false) : false;
            x.TaskDatetime = moment(new Date(x.TaskDatetime)).format(
              "DD-MMM-YYYY HH:mm:ss"
            );
          })
          this.listOfTaskTemp = [...this.listOfTask];
        }
      });
  }

  filterTask(e) {
    let isStatus = e.target.checked;
    this.listOfTask = isStatus ? this.listOfTaskTemp.filter(x => x.Status === true) : this.listOfTaskTemp;
  }

  onCompletedSwitch(e) {
    this.taskDetails.Status = e.target.checked;
  }

  //Resize the textbox 
  resizeTextArea(textArea: HTMLTextAreaElement) {
    textArea.style.height = 'auto'; // Reset the height
    textArea.style.height = `${textArea.scrollHeight}px`; // Set the new height
  }

  // Task From open
  addTask(isNew = false) {
    setTimeout(() => {
      this.GetDatePicker();
    }, 200)
    this.addTaskCheck = !this.addTaskCheck;
    this.showlistOfTask = false;
    this.taskDetails = isNew ? {} : this.taskDetails;
    console.log("In add Task");
  }

  onSaveClick() {
    this.saveAndUpdateTask(this.taskDetails);
  }

  saveAndUpdateTask(item) {
    item.Status = item.Status ? 'Completed' : null;
    item.TaskDatetime = $("#IDFromDate").val();
    if (item && item.TaskDatetime) {
      if (!item.Id) {
        item.UserId = this.userId;
        this.listOfTask.push({ ...item });
        this._appService
          .Post("Task", "CreateTask", item)
          .subscribe((response) => {
            this.getAllTask();
          });
      }
      else {
        const index = this.listOfTask.findIndex(task => task.Id === item.Id);
        if (index !== -1) {
          this.listOfTask[index] = item;
        }
        this._appService
          .Post("Task", "UpdateTask", item)
          .subscribe((response) => {
            this.getAllTask();
          });
      }
      this.taskDetails = {};
      this.showListOfTaskFn();
    }
  }

  GetDatePicker() {
    $(".datetimepicker")
      .each(function () {
        if ($(this).data("datetimepicker")) {
          $(this).datetimepicker("remove");
        }
        $(this).datetimepicker({
          todayHighlight: 1,
          orientation: "auto",
          autoclose: true,
          defaultViewDate: new Date(),
          format: "dd-M-yyyy hh:ii:ss", //dd-M-yyyy hh:ii:ss
        });
        if ($(this).val() == "") {
          $(this).datetimepicker("initialDate", new Date());
        } else {
          $(this).datetimepicker("initialDate", $(this).val());
        }
      })
      .on("click", function () {
        $(this).addClass("OpenDateTimePicker");
        $(".OpenDateTimePicker").not(this).datetimepicker("hide");
        $(".OpenDateTimePicker").not(this).removeClass("OpenDateTimePicker");
      });
  }

  showListOfTaskFn() {
    this.showlistOfTask = true;
    this.addTaskCheck = false;
  }

  deleteTask(item: any) {
    console.log("In delete Task");
    const index = this.listOfTask.findIndex(task => task.title === item.title);
    if (index !== -1) {
      this.listOfTask.splice(index, 1);
    }
    this._appService
      .Delete("Task", "DeleteTask", item.Id)
      .subscribe((response) => {
        console.log('delete successfully', response)
      });
  }

  editTask(item: any) {
    this.taskDetails = item;
    this.addTask();
  }

  //end for task

}
